export default __webpack_public_path__ + "static/media/interaction01.3b30e4e1.png";